import { Link } from '../../../api/contract-notice-dto';
import {
  BaseEntityDTO, BaseObjectDTO, DivisionDTO, DocumentClassDTO,
  LinkedActionsDTO, MasterDataDTO, TaskDTO, WorkDTO, DocumentDTO
} from '../../../api/plyca-dtos';
import { ProcurementProjectDTO, ProcurementProjectLotDTO, AwardDTO, ContractDTO, ObjectContextDTO } from '../../../api/plyca-dtos-v2';


export interface LotStateInfoDTO extends BaseObjectDTO<string> {
  award: AwardDTO;
  procurementProjectLot: ProcurementProjectLotDTO;
  // Lotes marcados para adjudicar
  markedForAwardLot: boolean;
  // Lotes marcados para desierto
  markedForDesertLot: boolean;
  awardAgreementDate: Date; // Fecha AcuerdoAdjudicacion;
}

export interface ProcurementProjectLotStateInfoDTO extends BaseObjectDTO<string> {
  procurementProject: ProcurementProjectDTO;
  allLotsAllStateInfo: LotStateInfoDTO[];
  workToDoLotsStateInfo: LotStateInfoDTO[];
  processedLotsStateInfo: LotStateInfoDTO[];
  desertedAgreementDatevate: Date;
}

export interface WorkProcurementProjectLotStateInfoDTO extends BaseObjectDTO<string> {
  procurementProjectLotStateInfo: ProcurementProjectLotStateInfoDTO;
}

export enum LotState {
  PENDIENTE_ADJUDICAR = 0,
  DESIERTO = 1,
  EN_TRAMITACION = 2,
  ADJUDICADO = 3,
  COMUNICADO_DESIERTO = 4
}

